import { JSX } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';

export type ImageProps = JSX.IntrinsicElements['img'] & {
  fallbackSrc?: string;
  aspectRatio?: number;
  wrapperClassName?: string;
};

export function Image({
  src,
  fallbackSrc,
  aspectRatio,
  wrapperClassName,
  className,
  ...props
}: ImageProps) {
  const [error, setError] = useState(false);

  const handleError = () => {
    if (fallbackSrc) setError(true);
  };

  const finalSrc = error && fallbackSrc ? fallbackSrc : src;

  const imgElement = (
    <img
      {...props}
      src={finalSrc}
      onError={handleError}
      class={clsx('image', className)}
    />
  );

  if (!aspectRatio) return imgElement;

  const padding = (1 / aspectRatio) * 100;

  return (
    <div
      class={clsx('image-wrapper', wrapperClassName)}
      style={{
        position: 'relative',
        width: '100%',
        paddingBottom: `${padding}%`,
      }}
    >
      <img
        {...props}
        src={finalSrc}
        onError={handleError}
        class={clsx('image', className)}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </div>
  );
}
